export default {
  path: '/help/:questionName?/',
  name: 'Help',
  meta: {
    title: 'Help',
    layout: 'standard',
    showOnSiteMap: true,
  },
  component: () => import(/* webpackChunkName: "PageHelp" */ './HelpPage.vue'),
  // prefetchChunks: ['TmlGlobal', 'TmlForms', 'TmlContainers'],
  children: [
    {
      path: 'reason/:reasonName?/',
      name: 'reason-name',
      meta: {
        title: 'Help',
        layout: 'standard',
        allowPwaReload: true,
      },
      component: () =>
        import(/* webpackChunkName: "PageHelp" */ './HelpPage.vue'),
    },
    {
      path: 'question/:questionName?/',
      name: 'question-name',
      meta: {
        title: 'Help',
        layout: 'standard',
        allowPwaReload: true,
      },
      component: () =>
        import(/* webpackChunkName: "PageHelp" */ './HelpPage.vue'),
    },
    /**
     * @deprecated legacy route for FAQ groups, now replaced with /help/?group={groupCode}
     */
    {
      path: 'group/:groupCode?/',
      name: 'group-code',
      meta: {
        title: 'Help',
        layout: 'standard',
        allowPwaReload: true,
      },
      component: () =>
        import(/* webpackChunkName: "PageHelp" */ './HelpPage.vue'),
    },
  ],
};
